import { z } from 'zod/v4';
import { companySchema } from './company.js';

export const AdminCompaniesListNetworkParamsSchema = z.object({
  id: z.string(),
});

export const AdminCompaniesListNetworkResponseSchema = z.array(companySchema);

export type AdminCompaniesListNetworkResponse = z.infer<
  typeof AdminCompaniesListNetworkResponseSchema
>;
